import React from 'react'
import * as XLSX from 'xlsx'

type Column = {
  key: string
  label: string
}

type Props = {
  columns?: Column[]
  data?: any[]
  fileName?: string
}

export const ExcelExport = ({
  columns = [],
  data = [],
  fileName = 'export'
}: Props) => {
  const exportExcel = () => {
    if (!columns.length || !data.length) return

    const rows = data.map(row => {
      const o: any = {}
      columns.forEach(c => {
        o[c.label] = row?.[c.key]
      })
      return o
    })

    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    const uniqueName = `${fileName}_${Date.now()}`
    XLSX.writeFile(wb, `${uniqueName}.xlsx`)
  }

  return (
    <button
      onClick={exportExcel}
      disabled={!data.length || !columns.length}
      style={{
        height: 34,
        padding: '0 14px',
        borderRadius: 8,
        border: '1px solid rgba(0,0,0,.1)',
        background: '#0eb17aff',
        fontSize: 13,
        fontWeight: 500,
        cursor: data.length ? 'pointer' : 'not-allowed',
        opacity: data.length ? 1 : 0.45,
        color:"white"
      }}
    >
      Export Excel
    </button>
  )
}
